import type { ComponentProps } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// 공식 Glow Pink 배경에는 가독성 기준에 맞는 Cocoa 글자를 사용한다.
export const buttonVariants = cva(
  'gp-control inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary: 'gp-cta bg-gp-pink-500 text-gp-ink-900 hover:bg-gp-pink-100',
        secondary: 'bg-gp-pink-100 text-gp-ink-900 hover:bg-gp-pink-100/80',
        outline:
          'border border-gp-ink-900/15 bg-white text-gp-ink-900 hover:bg-gp-pink-50',
        ghost: 'text-gp-ink-900 hover:bg-gp-pink-100/60',
        link: 'text-gp-pink-800 underline-offset-4 hover:underline',
      },
      size: {
        sm: 'h-9 px-4 text-caption',
        md: 'h-11 px-5 text-body',
        lg: 'h-13 px-6 text-h3',
        icon: 'size-10',
      },
      block: {
        true: 'w-full',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
);

export interface ButtonProps
  extends ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

export function Button({
  className,
  variant,
  size,
  block,
  asChild = false,
  ...props
}: ButtonProps) {
  const Component = asChild ? Slot : 'button';
  return (
    <Component
      className={cn(buttonVariants({ variant, size, block }), className)}
      {...props}
    />
  );
}
